import {Grid } from "@mui/material";
import React from "react";
import CategoriesHeader from "./home/header";
import CategoriesTabel from "./home/table";

const Categories = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CategoriesHeader />
      </Grid>
      <Grid item xs={12}>
        <CategoriesTabel />
      </Grid>
    </Grid>
  );
};

export default Categories;
